import { render, staticRenderFns } from "./GiftyTabs.vue?vue&type=template&id=522647c6&scoped=true&"
import script from "./GiftyTabs.vue?vue&type=script&lang=js&"
export * from "./GiftyTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522647c6",
  null
  
)

export default component.exports